/**
 * @generated SignedSource<<28de09285aef476849a1e84b8ebcaebd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RelationsSectionFragment$data = {
  readonly id: string;
  readonly trackedInIssues: {
    readonly totalCount: number;
  };
  readonly " $fragmentSpreads": FragmentRefs<"TrackedByItems">;
  readonly " $fragmentType": "RelationsSectionFragment";
};
export type RelationsSectionFragment$key = {
  readonly " $data"?: RelationsSectionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"RelationsSectionFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RelationsSectionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 10
        }
      ],
      "concreteType": "IssueConnection",
      "kind": "LinkedField",
      "name": "trackedInIssues",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        }
      ],
      "storageKey": "trackedInIssues(first:10)"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TrackedByItems"
    }
  ],
  "type": "Issue",
  "abstractKey": null
};

(node as any).hash = "bd5f8e3c76567a4447513629b2f19a5c";

export default node;
